module.exports = __webpack_public_path__ + "img/chevron-down-grey.e5642160.svg";